<div [class.payment-failed]="failedPayment">
  <cc-top-bar [title]="('ACCOUNTS.ACCOUNT' | translate)"></cc-top-bar>
  <div class="menu">
    <div>
      <a
        [routerLink]="['plan']"
        routerLinkActive="active-link"
        class="router-link"
        href="/plan">
        {{'MENU.PLAN' | translate}}
      </a>
      <a
        [routerLink]="['billing']"
        routerLinkActive="active-link"
        class="router-link"
        href="/billing">
        {{'MENU.BILLING' | translate}}
      </a>
      <a
        [routerLink]="['reports']"
        routerLinkActive="active-link"
        class="router-link"
        href="/reports">
        {{'MENU.REPORTS' | translate}}
      </a>
    </div>
  </div>
  <div class="app-container responsive-container" [class.payment-failed]="failedPayment">
    <router-outlet></router-outlet>
  </div>
</div>
